import { getPageNameWithoutRegion } from '@blueberry/utils/utility';

export const types = {
  FETCH_RELATED_PAGES: 'FETCH_RELATED_PAGES',
  FETCH_RELATED_PAGES_SUCCESS: 'FETCH_RELATED_PAGES_SUCCESS',
};

export const fetchRelatedPages = () => ({
  type: types.FETCH_RELATED_PAGES,
});

export const fetchRelatedPagesSuccess = pages => ({
  type: types.FETCH_RELATED_PAGES_SUCCESS,
  payload: {
    pages,
  },
});

const INIT_STATE = {
  pages: [],
};

export default function(state = INIT_STATE, action) {
  switch (action.type) {
    case types.FETCH_RELATED_PAGES_SUCCESS:
      return {
        ...state,
        pages: action.payload.pages,
      };
    default:
      return state;
  }
}

export const getRelatedPage = state => state.header.pages;

export const transformPages = pages => {
  return pages.map(page => ({
    ...page,
    nameWithoutRegion: getPageNameWithoutRegion(page.name),
  }));
};



// WEBPACK FOOTER //
// ./app/redux/header.js